import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente render muestre la UI de fallback
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Puedes también loggear el error a un servicio de reporte de errores
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar cualquier UI de fallback
      return (
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card">
                <div className="card-body text-center">
                  <h3>Algo salió mal</h3>
                  <p>Ha ocurrido un error inesperado. Por favor, recarga la página e inténtalo de nuevo.</p>
                  <button 
                    className="btn btn-primary"
                    onClick={() => window.location.reload()}
                  >
                    Recargar Página
                  </button>
                  {process.env.NODE_ENV === 'development' && this.state.error && (
                    <details style={{ whiteSpace: 'pre-wrap', marginTop: '20px' }}>
                      <summary>Detalles del Error (Solo desarrollo)</summary>
                      <p>{this.state.error && this.state.error.toString()}</p>
                      <p>{this.state.errorInfo.componentStack}</p>
                    </details>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 